import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';

import { Action, ContextAction, LinkAction, Spacer, isAction } from '../action.model';
import { ContextEvent, ContextMenuService } from './context-menu.service';

@Component({
  selector: 'cp-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContextMenuComponent implements OnInit {
  event: ContextEvent | undefined;
  private isOpening: boolean;

  constructor(private service: ContextMenuService, private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.service.contextEvents$.subscribe(event => {
      this.addHighlight(event);

      this.event = event;
      this.isOpening = true;
      this.changeDetector.markForCheck();
      setTimeout(() => this.isOpening = false, 400);
    });
  }

  @HostListener('document:click')
  clickedOutside(): void {
    if (!this.isOpening) {
      this.close();
    }
  }

  get locationStyle() {
    if (!this.event) {
      return {};
    }

    return {
      position: 'absolute',
      left: this.event.$event.pageX + 'px',
      top: this.event.$event.pageY + 'px'
    };
  }

  getName<T>(action: Action<T>, value: T) {
    return typeof action.name === 'function' ? action.name(value) : action.name;
  }

  getIcon<T>(action: Action<T>, value: T) {
    return typeof action.icon === 'function' ? action.icon(value) : action.icon;
  }

  isSpacer<T>(action: ContextAction<T>): action is Spacer {
    return !isAction(action);
  }

  isLink<T>(action: ContextAction<T>): action is LinkAction<any> {
    return action.type === 'link';
  }

  isVisible<T>(action: ContextAction<T>, value: T) {
    if (isAction(action)) {
      return action.isVisible(value);
    } else {
      return true;
    }
  }

  execute<T>(action: ContextAction<T>, value: T) {
    if (action.type !== 'executed') {
      return;
    }

    if (isAction(action)) {
      action.execute(value);
      this.close();
    }
  }

  close(): void {
    this.removeHighlight();
    this.event = undefined;
    this.changeDetector.detectChanges();
  }

  private removeHighlight() {
    if (this.event) {
      this.event.host.classList.remove('mod-context');
    }
  }

  private addHighlight(event: ContextEvent) {
    this.removeHighlight();
    event.host.classList.add('mod-context');
  }
}
